import Button from 'components/Button';
import styles from './styles/PhotoGalleryAlertModal.module.scss';
import { usePhotoGalleryContainer } from '..';
import Clickable from '@/components/Clickable';

export default function PhotoGalleryPurchaseConfirmation() {
  const [{}, { setAlertType }] = usePhotoGalleryContainer();
  return (
    <>
      <div className={styles.ModalHeading}>Purchase Successful</div>
      <div className={styles.ModalBody}>
        Your purchase has been completed! A link to download your photo(s) has been sent to the email you provided at checkout. Please
        contact{' '}
        <Clickable href="mailto:support@scorebooklive.com?subject=Photo Gallery Purchase Question">support@scorebooklive.com</Clickable> if
        you have any questions.
      </div>
      <Button label="Done" type="v2" className={styles.ModalCloseButton} onClick={() => setAlertType(null)} />
    </>
  );
}
